import { render, staticRenderFns } from "./KlippaOneTicketFromPicture.vue?vue&type=template&id=0d07690d&"
import script from "./KlippaOneTicketFromPicture.vue?vue&type=script&lang=js&"
export * from "./KlippaOneTicketFromPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d07690d')) {
      api.createRecord('0d07690d', component.options)
    } else {
      api.reload('0d07690d', component.options)
    }
    module.hot.accept("./KlippaOneTicketFromPicture.vue?vue&type=template&id=0d07690d&", function () {
      api.rerender('0d07690d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpenseService/KlippaOneTicketFromPicture.vue"
export default component.exports